module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/2_0-1a4bc0733f1e3fa9cec00a59cefc9e72.png";